<div class="tab-group-container">
  @for (tab of tabs(); track $index) {
    <div class="tab-item" [class.selected]="tab.value === currentSelectedIndex()" (click)="itemClicked(tab.value)" [class.disabled]="tab.disabled">
      {{ tab.title }}
    </div>
  }
</div>
